import Config from 'react-native-config';
import { Thunk } from 'store/types';
import { Coordinate, DispatcherAuthPrefix, DispatcherCategoryService } from 'modules/types/common';
import { IS_SERVICE_EXPANSION_ENABLED } from 'services/LocationService/constant';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import * as liveCareSelectors from './selectors';

export const GET_FACILITIES = 'CARE.GET_FACILITIES';
export const GET_FACILITIES_SUCCESS = 'CARE.GET_FACILITIES_SUCCESS';
export const GET_FACILITIES_FAIL = 'CARE.GET_FACILITIES_FAIL';

export const GET_GEOCODE = 'CARE_GET_GEOCODE';
export const GET_GEOCODE_SUCCESS = 'CARE_GET_GEOCODE_SUCCESS';
export const GET_GEOCODE_FAIL = 'CARE_GET_GEOCODE_FAIL';
export const LIVE_CARE_LOCATION_TEXT = 'LIVE_CARE_LOCATION_TEXT';
export const CHECK_GEO_LOCATION_PERMISSION = 'CHECK_GEO_LOCATION_PERMISSION';

export const setLocationText = (value: string) => ({
  type: LIVE_CARE_LOCATION_TEXT,
  payload: value,
  isFetching: true
});
export const getFacilities = (
  coords: Partial<Coordinate>,
  useCache? = false,
  searchCity?: string
) => ({
  type: GET_FACILITIES,
  payload: {
    client: 'getCare',
    cache: useCache,
    request: {
      url: IS_SERVICE_EXPANSION_ENABLED
        ? getDispatcherUrl(
            DispatcherCategoryService.UTILITY,
            DispatcherAuthPrefix.PUBLIC,
            '',
            '/facilities'
          )
        : 'locations',
      params: {
        longitude: coords.longitude,
        latitude: coords.latitude,
        page: 0,
        limit: 50,
        brand: 'ih',
        ...(searchCity && { city: searchCity })
      },
      headers: IS_SERVICE_EXPANSION_ENABLED
        ? {
            'mhp-adapter': 'mhp'
          }
        : {}
    }
  }
});

export const getGeocode = (input: string) => {
  return {
    type: GET_GEOCODE,
    payload: {
      request: {
        url: `${Config.GOOGLE_GEOCODE_ENDPOINT}json`,
        params: {
          address: input,
          key: Config.GOOGLE_GEOCODE_KEY
        }
      }
    }
  };
};

export const getLocalFacilities = (input: string): Thunk => async (dispatch, getState) => {
  if (input) {
    await dispatch(getGeocode(input));
  }

  const geolocationCoordinates = liveCareSelectors.googleGeolocationCoordinatesSelector(getState());
  await dispatch(getFacilities(geolocationCoordinates));
};
